import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { OVERLAY_DEFAULT_CONFIG } from '@angular/cdk/overlay';

/**
 * CDK 21 opens overlays (Material dialogs and menus, Nebular dialogs and popovers) as popovers, in
 * the browser's top layer. PrimeNG and AG Grid append their dropdowns to <body>, and no z-index
 * lifts an element above the top layer, so a dropdown opened inside a dialog ended up underneath
 * it. Keep CDK overlays in the z-indexed `.cdk-overlay-container`, as before Angular 21.
 */
export function provideCdkOverlaysBelowBodyPopups(): EnvironmentProviders {
  return makeEnvironmentProviders([
    { provide: OVERLAY_DEFAULT_CONFIG, useValue: { usePopover: false } },
  ]);
}
